import React from 'react';
import cl from './DateTemplate.module.css';
import {useGridCellHandleClick} from "../../../../../../components/ui/Grid/Telerik/hooks/useGridCellHandleClick";
import moment from "moment/moment";

const DateTemplate = (props: any) => {
    const {handleClick} = useGridCellHandleClick(props.dataItem);

    return (
        <td {...props.tdProps}
            colSpan={1}
            onClick={handleClick}>
                <span className={`default-left-cell default-overflow-cell`}>
                    {moment.utc(props.children, 'DD.MM.YY HH:mm').local().format('DD.MM.YYYY HH:mm')}
                </span>
        </td>
    );
};

export default DateTemplate;
